import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

import DepartmentRepository from '@/shared/http/repositories/configuration/department'
import DepartmentModel from '@/shared/models/configuration/departmentmodel'
import DepartmentForms from './department-form'

export default {
  name: 'Department',
  mixins: [ActionsForm],
  data () {
    return {
      data: DepartmentModel,
      form: DepartmentForms
    }
  },
  computed: {
    FieldSizeTip: function () {
      return this.$lang.Common.Tips.MaximumSize.replace('@SIZE@', this.form.description.maxlength)
    }
  },
  methods: {
    onLoad () {
      loading.push()
      DepartmentRepository.GetAllPagingByCompany(this.CompanySelected, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
    /*,
    onCreate () {
      loading.push()
      DepartmentRepository.Create(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onUpdate () {
      loading.push()
      DepartmentRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onDelete (obj) {
      loading.push()
      DepartmentRepository.Delete(obj.id)
        .then((response) => {
          this.onResult(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    }
    */
  }
}



// WEBPACK FOOTER //
// ./src/views/private/configuration/department/department.js